import { useMutation } from '@/core/hooks/use-mutation'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { updatePassword } from '../../providers/client'
import { updatePasswordSchema } from '../../types/dtos/update-password.dto'

export const useUpdatePassword = ({ onSuccess }: { onSuccess: () => void }) => {
  const form = useForm({
    defaultValues: {
      current_password: '',
      new_password: '',
      new_password_confirmation: '',
    },
    resolver: zodResolver(updatePasswordSchema),
  })

  const { isPending, mutate } = useMutation({
    mutation: updatePassword,
    onSuccess,
    onError(error) {
      form.setError('current_password', { message: error })
    },
  })

  const handleSubmit = form.handleSubmit(mutate)

  return { form, handleSubmit, isPending }
}
